// Lavet af Christian Andrés (15-10-2026) - projekt: pagespeed (v3.1) - 13: samme opførsel som før, men uden jQuery
// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.5) - punkt 9: tastatur. Enter/mellemrum på en åbner, der ikke er en knap,
// Escape lukker, fokus flyttes til krydset ved åbning og tilbage til åbneren ved lukning. Klik virker som før.
function sliderInit(openerQuery, sliderQuery) {
	const slider = document.querySelector(sliderQuery);
	if (!slider) return;
	const openers = document.querySelectorAll(openerQuery);
	const togglers = document.querySelectorAll(`${openerQuery}, ${sliderQuery} .slideout-close`);

	const inner = slider.querySelector(":scope > .slideout--inner");
	let lastOpener = null;

	function setExpanded(isOpen) {
		openers.forEach(function (opener) {
			if (opener.hasAttribute("aria-expanded")) opener.setAttribute("aria-expanded", isOpen ? "true" : "false");
		});
	}

	function close() {
		document.body.classList.remove("no-scroll");
		setExpanded(false);
		if (lastOpener && slider.contains(document.activeElement)) lastOpener.focus();
		lastOpener = null;

		slider.classList.remove("fade-in");
		if (!inner) {
			slider.classList.remove("open");
			return;
		}
		inner.classList.remove("open-inner");
		inner.addEventListener(
			"transitionend",
			function () {
				slider.classList.remove("open");
			},
			{ once: true }
		);
	}

	function toggle(toggler) {
		document.body.classList.add("no-scroll");
		if (slider.classList.contains("open")) {
			close();
			return;
		}
		slider.classList.add("slideout--outer", "open", "fade-in");
		if (inner) inner.classList.add("open-inner");
		setExpanded(true);
		// Fokus skal tilbage til noget, der kan få fokus (åbneren selv eller en knap inde i den)
		lastOpener =
			toggler && (toggler.matches("button, a[href], [tabindex]") ? toggler : toggler.querySelector("button, a[href], [tabindex]"));
		const closeButton = slider.querySelector(".slideout-close");
		if (closeButton) closeButton.focus({ preventScroll: true });
	}

	/* Opener */
	togglers.forEach(function (toggler) {
		toggler.addEventListener("click", function (event) {
			event.stopPropagation();
			toggle(toggler);
		});
		// Knapper og links klarer Enter/mellemrum selv
		if (toggler.matches("button, a[href]")) return;
		toggler.addEventListener("keydown", function (event) {
			// Kun når åbneren selv har fokus (fx ikke knappen inde i #oos-slideout-button)
			if (event.target !== toggler) return;
			if (event.key !== "Enter" && event.key !== " ") return;
			event.preventDefault();
			toggler.click();
		});
	});

	/* Wrapper click listener */
	slider.addEventListener("click", function (event) {
		if (event.target !== slider) return;
		close();
	});

	document.addEventListener("keydown", function (event) {
		if (event.key === "Escape" && slider.classList.contains("open")) close();
	});
}
